<div class="article-viewer" *ngIf="!isLoading && article">
    <!-- Article Header -->
    <div class="article-header">
        <span *ngIf="article.categoryName" class="article-category">{{article.categoryName}}</span>
        <h1 class="article-title">{{article.title}}</h1>
        <div class="article-meta">
            <span *ngIf="article.lastModifiedDate">
                <i class="pi pi-clock"></i>
                Aktualisiert: {{article.lastModifiedDate | date:'dd.MM.yyyy'}}
            </span>
            <span>
                <i class="pi pi-eye"></i>
                {{article.viewCount}} Aufrufe
            </span>
        </div>
    </div>

    <!-- Article Summary -->
    <div *ngIf="article.summary" class="article-summary">
        <p>{{article.summary}}</p>
    </div>

    <!-- Article Content (HTML from TinyMCE) -->
    <div class="article-content" [innerHTML]="article.content"></div>

    <!-- Tags -->
    <div *ngIf="article.tagsJson" class="article-tags">
        <!-- Tags are stored as JSON array -->
    </div>

    <!-- Feedback -->
    <div class="article-feedback">
        <div *ngIf="!feedbackSubmitted" class="feedback-question">
            <span>War dieser Artikel hilfreich?</span>
            <div class="feedback-buttons">
                <button pButton
                        icon="pi pi-thumbs-up"
                        label="Ja"
                        class="p-button-outlined p-button-success p-button-sm"
                        (click)="onFeedback(true)">
                </button>
                <button pButton
                        icon="pi pi-thumbs-down"
                        label="Nein"
                        class="p-button-outlined p-button-danger p-button-sm"
                        (click)="onFeedback(false)">
                </button>
            </div>
        </div>
        <div *ngIf="feedbackSubmitted" class="feedback-thanks">
            <i class="pi pi-check-circle"></i>
            <span>Vielen Dank fuer Ihr Feedback!</span>
        </div>
    </div>

    <!-- Related Articles -->
    <div *ngIf="relatedArticles.length > 0" class="related-articles">
        <h3>Verwandte Artikel</h3>
        <div class="related-list">
            <div *ngFor="let related of relatedArticles"
                 class="related-item"
                 (click)="onRelatedArticleClick(related)">
                <i class="pi pi-file-edit"></i>
                <span>{{related.title}}</span>
            </div>
        </div>
    </div>
</div>

<!-- Loading -->
<div *ngIf="isLoading" class="article-loading">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
    <p>Artikel wird geladen...</p>
</div>
